{
  "it": {
    "building": {
      "attributes": {
        "description": "Descrizione",
        "elevators": "Numero di ascensori",
        "end_date": "Data di fine",
        "floors": "Numero di piani",
        "internal_note": "Nota interna dell'edificio",
        "name": "Nome",
        "start_date": "Data di inizio",
        "surface_shared": "Superficie condivisa"
      },
      "labels": {
        "building": "Nessun edificio | Un edificio | {count} edifici"
      },
      "toasts": {
        "create": "Edificio creato",
        "delete": "Edificio eliminato",
        "update": "Edificio aggiornato"
      },
      "validation": {
        "needName": "Il titolo è obbligatorio",
        "needNumber": "Deve essere un numero (ad es. 85)"
      }
    }
  }
}
